// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { GridOverlay, GridToolbar } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../common/components';
import { DateUtils } from '../../../../common/utils';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
}));

function LogInfoTab(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { data } = props;

  const getColumnDefs = () => [
    {
      field: 'timestamp',
      headerName: t('logInfo.logInfoTimestamp'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'eventType',
      headerName: t('logInfo.logInfoEventType'),
      width: 200,
    },
    {
      field: 'message',
      headerName: t('logInfo.logInfoMessage'),
      width: 300,
      flex: 1,
    },
  ];

  const getRowData = () =>
    data.map((logInfo, index) => ({
      ...logInfo,
      id: index,
    }));

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('logInfo.logInfoEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="LogInfoTab-container" className={classes.container}>
      <DataTable
        id="LogInfoTab-table"
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={20}
        paginationMode="client"
        pagination
      />
    </Box>
  );
}

LogInfoTab.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default LogInfoTab;
